// JS que envia a cheakout y agrega notas adicionales de entregas y datos de envio extras

js_checkout()
function js_checkout(){
    document.addEventListener('DOMContentLoaded', initCheckout)
}

function initCheckout() {
    const buttons = document.querySelectorAll('.js-chackout__button')
    const notes = document.querySelectorAll('.js-chackout__note')
    const nota_envio = document.querySelector('.js-chackout__nota-envio')
    
    let note
    
    $('.datepicker').pickadate({
        labelMonthNext: 'Next month',
        labelMonthPrev: 'Previous month',
        today: '',
        clear: '',
        close: '',
        weekdaysShort: ['D', 'L', 'M', 'M', 'j', 'V', 'S']
    })

    init()
    
    function init() {
        if (buttons != null) {
            buttons.forEach(button => {
                button.addEventListener('click', e => {
                    e.preventDefault()
                    
                    let envio = false
                    button.classList.forEach(element => {
                        if (element == 'is-envio') {
                            envio = true
                        }    
                    })
                    
                    if (envio) {
                        const button = document.querySelector('.js-chackout__button-envio.is-pop')
                        const envio = document.querySelector('.js-chackout__envio')

                        if (button != null) {
                            if (envio.innerHTML != 'Sin fecha') {
                                checkNotes()
                            }else{
                                nota_envio.classList.add('d-block')
                            }
                        }else{
                            nota_envio.classList.add('d-block')
                        }
                    }else{
                        checkNotes()
                    }
                })
            })
        }
    }

    function checkNotes() {
        note = ' '

        notes.forEach(note => {
            const active = note.querySelector('.js-chackout__active.is-pop')
            if (active != null) {
                const labels = note.querySelectorAll('.js-chackout__label')
                const inputs = note.querySelectorAll('.js-chackout__input')

                noteArray(labels, inputs)
            }
        })
        postNote(note)
    }

    function noteArray(labels, inputs) {
        for (let i = 0; i < labels.length; i++) {
            note += `${labels[i].innerHTML} ${inputs[i].value} || `
        }
    }

    function postNote(note) {
        $.ajax({
            url: "/cart/update.js",
            type: "post",
            data: {
                note: note
            },
            dataType: 'json',
            async: false,
            success: res => {
                console.log(res)
                window.location = '/checkout'
            },
            error: error => {
                console.log(error)
            }
        })
    }
}
